<script lang="ts" module>
  import { createHighlighter } from "shiki";

  const highlighter = await createHighlighter({
    themes: ["vitesse-light"],
    langs: ["python"],
  });
</script>

<script lang="ts">
  import { Check, Copy } from "lucide-svelte";
  import type { ClassValue } from "svelte/elements";

  import type { ExtendedRow } from "./process-rows";
  import { SglangSnippet, TensorrtllmSnippet, VllmSnippet } from "./snippets";

  interface Props {
    row: ExtendedRow;
    class?: ClassValue;
    mobile?: boolean;
  }

  let { row, class: className, mobile }: Props = $props();

  let framework = $derived(row.framework);

  let snippet: string | null = $derived.by(() => {
    switch (framework) {
      case "vllm":
        return VllmSnippet(row);
      case "tensorrt-llm":
        return TensorrtllmSnippet(row);
      case "sglang":
        return SglangSnippet(row);
      default:
        return null;
    }
  });

  let copied = $state(false);
  $effect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        copied = false;
      }, 5000);
      return () => clearTimeout(timeout);
    }
  });
</script>

<div
  class={[
    "container",
    "text-sm rounded-md max-w-full bg-[#f1f2f0] grid",
    "transition-[box-shadow,transform]",
    className,
  ]}
>
  <div class="code-wrapper col-span-full p-4">
    {@html highlighter.codeToHtml(snippet?.trimEnd() ?? "", {
      lang: "python",
      theme: "vitesse-light",
    })}
  </div>
</div>
<button
  class={[
    "flex items-center gap-1 rounded-[3px] bg-[#DBE0DD] hover:bg-white transition-colors border border-almanac-dark-green/30 px-2 py-1",
    !mobile ? "mt-6" : undefined,
    "absolute top-4 right-4 pointer-events-auto text-sm font-mono",
  ]}
  onclick={() => {
    if (snippet) {
      navigator.clipboard.writeText(snippet);
      copied = true;
    }
  }}
>
  {#if copied}
    <Check class="w-4 h-4" />
    <div>uvx modal run this.py</div>
  {:else}
    <Copy class="w-4 h-4" /> Copy
  {/if}
</button>

<style lang="postcss">
  .code-wrapper > :global(pre) {
    @apply !bg-transparent;
  }

  :global(.group):hover .container {
    /* Copied from FiltersContainer.svelte */
    box-shadow:
      0 4px 12px rgba(23, 69, 12, 0.2),
      0 0 0 1px rgba(23, 69, 12, 0.06);
  }
</style>
